
import * as handlebars_family from "../handlebars_family.ts";
import "../nc/layout.mustache";
import "../widget/form/required.ts";
import "../widget/form/password.ts";
import "../widget/form/rememberme.ts";
const TPL = handlebars_family.addTemplate("nc/signin",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"familyName") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data,"loc":{"start":{"line":1,"column":109},"end":{"line":1,"column":408}}})) != null ? stack1 : "")
    + " ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.footerinvitee",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":131},"end":{"line":1,"column":167}}})) != null ? stack1 : "")
    + "</p> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"homehubActivation") : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":1,"column":181},"end":{"line":1,"column":400}}})) != null ? stack1 : "")
    + " ";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"homehubActivation.auth.noAccount",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":210},"end":{"line":1,"column":255}}})) != null ? stack1 : "")
    + " <a href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"homehubSignUpUrl") : depth0), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"homehubActivation.auth.createAccount",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":289},"end":{"line":1,"column":338}}})) != null ? stack1 : "")
    + "</a></p> ";
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.footer",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":359},"end":{"line":1,"column":388}}})) != null ? stack1 : "")
    + "</p> ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"familyName") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.program(15, data, 0),"data":data,"loc":{"start":{"line":1,"column":434},"end":{"line":1,"column":1038}}})) != null ? stack1 : "")
    + " <div id=\"error-container\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"error") : depth0),{"name":"if","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1065},"end":{"line":1,"column":1106}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"error") : depth0),{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1107},"end":{"line":1,"column":1123}}})) != null ? stack1 : "")
    + "</div><label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.email",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1137},"end":{"line":1,"column":1165}}})) != null ? stack1 : "")
    + " <input type=\"text\" name=\"a00identifier\" id=\"identifier\" placeholder=\"you@example.com\" data-widget=\"widget/form/required\" data-fw-form-required-error=\"nc.fields.identifierrequired\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"email\" maxlength=\"250\" value=\""
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"alreadymember") : depth0),{"name":"if","hash":{},"fn":container.program(22, data, 0),"inverse":container.program(24, data, 0),"data":data,"loc":{"start":{"line":1,"column":1448},"end":{"line":1,"column":1526}}})) != null ? stack1 : "")
    + "\"/></label><label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.password",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1545},"end":{"line":1,"column":1576}}})) != null ? stack1 : "")
    + " <div data-widget=\"widget/form/password\"><input type=\"password\" name=\"a00password\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"current-password\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.password",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1762},"end":{"line":1,"column":1793}}})) != null ? stack1 : "")
    + "\" data-widget=\"widget/form/required\"></div><a href=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"URL") : depth0)) != null ? lookupProperty(stack1,"PASSWORD_FORGOTTEN") : stack1), depth0))
    + "\" class=\"hint\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.forgotpassword",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1886},"end":{"line":1,"column":1923}}})) != null ? stack1 : "")
    + "</a></label><p><icon data-widget=\"widget/form/rememberme\" style=\"color:"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"FizConfig") : depth0)) != null ? lookupProperty(stack1,"defaultColor") : stack1), depth0))
    + ";margin-right:5px\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_checkbox",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":2039},"end":{"line":1,"column":2064}}}))
    + "</icon><span style=\"vertical-align: middle;\" data-fw-onclick=\"clickprev\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.rememberme",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2137},"end":{"line":1,"column":2170}}})) != null ? stack1 : "")
    + "</span></p><button type=\"submit\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":2203},"end":{"line":1,"column":2232}}})) != null ? stack1 : "")
    + "</button></form> ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <form data-fw-dyn-action=\"custom.signinoninvite\"><img class=\"nc-image\" src=\"/images/nc/invitation_acceptance_image_step_0@2x.png\"><h1>"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"alreadymember") : depth0),{"name":"if","hash":{},"fn":container.program(11, data, 0),"inverse":container.program(13, data, 0),"data":data,"loc":{"start":{"line":1,"column":587},"end":{"line":1,"column":706}}})) != null ? stack1 : "")
    + "</h1> ";
},"11":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.titleinviteealreadymember",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":608},"end":{"line":1,"column":656}}})) != null ? stack1 : "");
},"13":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.titleinvitee",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":664},"end":{"line":1,"column":699}}})) != null ? stack1 : "");
},"15":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <form data-fw-dyn-action=\"custom.signin\"><input type=\"hidden\" name=\"a00generateAutologinToken\" value=\"true\"/> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"homehubActivation") : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.program(18, data, 0),"data":data,"loc":{"start":{"line":1,"column":831},"end":{"line":1,"column":1030}}})) != null ? stack1 : "")
    + " ";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"homehubActivation.auth.signin.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":861},"end":{"line":1,"column":909}}})) != null ? stack1 : "")
    + "</h1><p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"homehubActivation.auth.signin.description",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":917},"end":{"line":1,"column":971}}})) != null ? stack1 : "")
    + "</p> ";
},"18":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.signin.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":989},"end":{"line":1,"column":1017}}})) != null ? stack1 : "")
    + "</h1> ";
},"20":function(container,depth0,helpers,partials,data) {
    return "style=\"display:block\"";
},"22":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"identifier") : depth0), depth0));
},"24":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"invitation") : depth0)) != null ? lookupProperty(stack1,"token") : stack1)) != null ? lookupProperty(stack1,"email") : stack1), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"$splash") || (depth0 != null ? lookupProperty(depth0,"$splash") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"$splash","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":11}}}) : helper)))
    + " "
    + ((stack1 = (lookupProperty(helpers,"var")||(depth0 && lookupProperty(depth0,"var"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"footer",{"name":"var","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":417}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"nc/layout"),depth0,{"name":"nc/layout","fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;